// extracted by mini-css-extract-plugin
export default {"info":"info--UpKHm","info-value":"info-value--AJtkL","info-sub":"info-sub--eap1k","info-sub-text":"info-sub-text--sZ_yC","disabled":"disabled--bhZW7"};